export const ARCHIVED_REASONS_LABELS = {
	"canceled": "Projet annulé",
	"by-other-provider": "J’ai choisi un autre prestataire",
	"by-construction-company": "Le projet a été réalisé par l’entreprise de travaux",
	"by-myself": "J’ai réalisé le projet par mes propres moyens",
	"too-expensive": "Le devis est trop élevé",
	"too-long": "Délais trop longs",
	"abandoned": "Je ne souhaite plus réaliser le projet",
	"other": "Autre",
};

export const mapArchivedReasonsWithLabels = (data = []) => {
	return data.map((item) => {
		const code = item.type || item.control || item.reason || item.code;
		const label = ARCHIVED_REASONS_LABELS[code] || code;

		return {
			...item,
			type: label,
		};
	});
};
